import {
  clientIdColumnDefinition,
  emailColumnDefinition,
  titleColumnDefinition,
  bodyTextColumnDefinition,
  nameColumnDefinition,
  nameOverrideColumnDefinition,
  statusColumnDefinition,
  typeColumnDefinition,
} from '../columnDefinitions';

export default [
  clientIdColumnDefinition,
  { ...emailColumnDefinition, field: 'authorEmail' },
  titleColumnDefinition,
  bodyTextColumnDefinition,
  nameColumnDefinition,
  nameOverrideColumnDefinition,
  { ...statusColumnDefinition, field: 'status' },
  typeColumnDefinition,
];
